import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React from "react";
import { showTermInfo } from "./TermInfoDialog";
import { showConfirmPass } from "./ConfirmPasswordDialog";

import BaseLayout from "../../../components/BaseLayout/BaseLayout";
import { css, cx } from "emotion";
import InvoiceService from "../../../Services/InvoiceService";
import { handleError } from "../../../components/Utils/Utils";
import TenantStore from "../../../Store/TenantStore";
import { Skeleton } from "@material-ui/lab";
import History from "../../../History/History";
import moment from "moment-timezone";
import { formatCurrency } from "../../../components/Utils/Currency";
import RefreshIcon from "@material-ui/icons/Refresh";
import { Checkbox } from "@material-ui/core";

const tableStyle = css`
  min-width: 650px !important;
  thead tr th {
    background-color: #eeeeee;
    padding: 13px 14px;
    font-size: 10px;
    font-weight: bold;
    color: #212121;
    border: none;
  }

  tbody tr {
    border-bottom: 1px solid #eeeeee;
  }

  tbody tr td {
    padding: 13px 14px;
    font-size: 10px;
    color: #212121;
    border: none;
    vertical-align: middle;
  }
`;

const Withdraw = (props) => {
  const [tenantState, tenantActions] = TenantStore();
  const [bank, setBank] = React.useState({});
  const [state, setState] = React.useState({
    orders: [],
    isLoading: false,
  });

  const [billingInvoiceOrder, setBillingInvoiceOrder] = React.useState([]);
  const  minWidrawAmount = 10000;
  const [totalWithdrawAmount, setTotalWithdrawAmount] = React.useState(0);


  const handleChangeInvoiceOrder = (event) => {
    const checked = event.target.checked;
    const data = JSON.parse(event.target.value);
    let arrBillingInvoiceOrder = [];

    if (checked) {
      const order = {
        transaction_id: data.unique_id,
        order_id: data.orders[0].id,
        tenant: data.orders[0].tenant,
        user: data.user,
        items: data.orders[0].items,
        total_item: data.orders[0].sub_total_item,
        total_amount: data.orders[0].sub_total_amount,
        service_charge_amount: data.orders[0].service_charge_amount,
        tax_charge_amount: data.orders[0].tax_charge_amount,
        trx_time: data.create_time,
        cancel: false,
        completed: false,
        progress: "new",
      };

      arrBillingInvoiceOrder = billingInvoiceOrder;
      arrBillingInvoiceOrder.push(order);

      setBillingInvoiceOrder(arrBillingInvoiceOrder);
    } else {
      arrBillingInvoiceOrder = billingInvoiceOrder.filter((val, key) => {
        return val.transaction_id !== data.unique_id;
      });

      setBillingInvoiceOrder(arrBillingInvoiceOrder);
    }

    let total = 0;
    arrBillingInvoiceOrder.map((val) => {
      total = total + val.total_amount;
    });

    setTotalWithdrawAmount(total);
  };

  const getBankName = (code) => {
    InvoiceService.getListBank()
      .then((response) => {
        let filteredData = response.filter((row) => {
          return row.bank_code === code;
        });

        setBank(filteredData[0]);
        return filteredData[0]?.bank_name;
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const getDetailTenant = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    tenantActions
      .getByID(user?.tenant?.id)
      .then((response) => {
        if (response.bank_account_number !== "") {
          getBankName(response.bank_code);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getListInvoiceOrder = () => {
    setTotalWithdrawAmount(0);
    const params = {
      sort: "oldest",
      progress: "complete",
      unlimited: "true",
    };
    setState({
      orders: [],
      isLoading: true,
    });
    InvoiceService.getInvoiceOrderList(params)
      .then((response) => {
        let data = response.data;
        const orders = data.filter((val, index) => {
          return val.settled_st;
        });
        setState({
          orders: orders,
          isLoading: false,
        });
      })
      .catch((error) => {
        setState({
          orders: [],
          isLoading: false,
        });
        handleError(error);
      });
  };

  const resetBillingInvoiceOrder = () => {
    setBillingInvoiceOrder([]);
  };

  const onClickTermInfo = () => {
    showTermInfo();
  };

  const onClickWithdrawButton = () => {
    showConfirmPass(
      totalWithdrawAmount,
      tenantState?.tenant,
      bank,
      billingInvoiceOrder,
      getListInvoiceOrder,
      resetBillingInvoiceOrder
    );
  };

  React.useEffect(() => {
    const initialLoad = () => {
      getDetailTenant();
      getListInvoiceOrder();
    };

    initialLoad();
  }, []);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12">
          <div
            className={cx(
              css`
                border-radius: 8px !important;
              `,
              "card card-body border-0 p-0 pb-4"
            )}
          >
            <div className="py-3 px-4">
              <div className="mb-3">
                <button
                  type="button"
                  className="btn pl-0"
                  onClick={() => {
                    History.push(`/saldosaya`);
                  }}
                >
                  <ArrowBackIcon />
                  <h3 className="font-16 font-bold mb-0 ml-2 d-inline">
                    Tarik Saldo
                  </h3>
                </button>
              </div>
              <div
                className={cx(
                  css`
                    border-radius: 8px !important;
                    margin: 0px 6px !important;
                  `,
                  "row justify-content-end align-items-center border-1-secondary py-2 px-3 mx-0"
                )}
              >
                <div className="col-sm-12 col-lg-3 mr-auto">
                  <div className="my-3">
                    <span className="font-12 d-block mb-2">Saldo</span>
                    <span className="font-20 font-bold">
                      {formatCurrency(
                        tenantState?.tenant?.property?.currency ||
                          process.env.REACT_APP_CURRENCY_CODE,
                        totalWithdrawAmount.toString()
                      )}
                    </span>
                    <button
                      type="button"
                      className={cx(
                        css`
                          border: none !important;
                          padding: 11px 17px !important;
                          border-radius: 8px !important;
                          font-size: 8px !important;
                          background-color: #2196f3 !important;
                        `,
                        "btn btn-info ml-2"
                      )}
                      onClick={() => onClickWithdrawButton()}
                      disabled={
                        totalWithdrawAmount >= minWidrawAmount &&
                        tenantState?.tenant?.bank_account_number !== ""
                          ? false
                          : true
                      }
                    >
                      Tarik Saldo
                    </button>
                    {(totalWithdrawAmount < minWidrawAmount && totalWithdrawAmount !== 0) &&
                      <span className="d-block text-danger font-12 mt-2">Minimal penarikan Rp 10.000</span>
                    }
                  </div>
                </div>
                <div
                  className={cx(
                    css`
                      border-left: 1px solid #eeeeee !important;

                      @media (max-width: 768px) {
                        border-left: none !important;
                        border-top: 1px solid #eeeeee !important;
                      }
                    `,
                    "col-sm-12 col-lg-3 px-2"
                  )}
                >
                  <div
                    className={cx(
                      css`
                        min-height: 92px;
                      `,
                      "d-flex justify-content-center align-items-center"
                    )}
                  >
                    <p className="text-muted font-10">
                      Dengan klik tombol <b>Tarik Saldo</b>, kamu telah setuju
                      dengan ketentuan{" "}
                      <span
                        onClick={() => onClickTermInfo()}
                        className={cx(
                          css`
                            color: #2196f3 !important;
                          `,
                          "font-bold cursor-pointer"
                        )}
                      >
                        Penarikan Saldo
                      </span>
                      .
                    </p>
                  </div>
                </div>
                <div
                  className={cx(
                    css`
                      border-left: 1px solid #eeeeee !important;

                      @media (max-width: 768px) {
                        border-left: none !important;
                        border-top: 1px solid #eeeeee !important;
                      }
                    `,
                    "col-sm-12 col-lg-3 px-2"
                  )}
                >
                  <div
                    className={cx(
                      css`
                        min-height: 92px;
                      `,
                      "d-flex flex-column justify-content-center align-items-start"
                    )}
                  >
                    <span className="d-block font-12 d-block mb-2">
                      Rekening Bank Saya
                    </span>
                    <div>
                      {tenantState?.isLoading && (
                        <p className="font-14 text-primary">
                          <Skeleton
                            variant="text"
                            animation="wave"
                            width={160}
                          />
                          <Skeleton
                            variant="text"
                            animation="wave"
                            width={120}
                          />
                        </p>
                      )}

                      {!tenantState?.isLoading &&
                        tenantState?.tenant?.bank_account_number !== "" && (
                          <p className="font-14 font-bold text-primary">
                            {` ${bank.bank_name} | ${tenantState?.tenant?.bank_account_number} | ${tenantState?.tenant?.bank_account_name}`}
                          </p>
                        )}

                      {!tenantState?.isLoading &&
                        tenantState?.tenant?.bank_account_number === "" && (
                          <p className="font-14 font-bold text-danger">
                            {`Silahkan Menghubungi Pihak Mall ${tenantState?.tenant?.property?.name} Untuk Memasukkan Rekening`}
                          </p>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="border-bottom-1-secondary mt-4 mb-0" />
            </div>
            <div className="d-flex justify-content-between align-items-center px-4 mb-3">
              <h5 className="font-bold text-primary font-16 mb-0">
                Pilih biaya yang ingin dicairkan
              </h5>
              <button
                type="button"
                className="btn btn-lg pr-0"
                onClick={() => getListInvoiceOrder()}
              >
                <RefreshIcon />
              </button>
            </div>
            <div className="table-responsive">
              <table className={cx(tableStyle, "table table-custom-1")}>
                <thead>
                  <tr>
                    <th width="5%"></th>
                    <th width="20%">No. Transaksi</th>
                    <th width="20%">Nama Pembeli</th>
                    <th width="15%">Tanggal Transaksi</th>
                    <th width="40%">Jumlah</th>
                  </tr>
                </thead>
                <tbody>
                  {!state?.isLoading &&
                    state?.orders?.map((row, index) => {
                      return (
                        <tr key={index}>
                          <td width="5%" className="text-center">
                            {tenantState?.tenant?.bank_account_number !== "" && (
                              <Checkbox
                                color="secondary"
                                inputProps={{ "aria-label": row.unique_id }}
                                value={JSON.stringify(row)}
                                onChange={(e) => handleChangeInvoiceOrder(e)}
                              />
                            )}
                          </td>
                          <td width="20%">
                            <span
                              className={cx(
                                css`
                                  color: #2196f3 !important;
                                `,
                                "font-12"
                              )}
                            >
                              {row.unique_id || ""}
                            </span>
                          </td>
                          <td width="20%">{row.user.name || ""}</td>
                          <td width="15%">
                            {moment(row.create_time)
                              .tz(row.orders[0].tenant.property.timezone)
                              .format("DD-MM-YYYY")}
                          </td>
                          <td width="40%">
                            <span
                              className={cx(
                                css`
                                  color: #4caf50 !important;
                                `,
                                "font-bold font-12"
                              )}
                            >
                              {formatCurrency(
                                row.orders[0].tenant.property.currency,
                                row.orders[0].sub_total_amount.toString()
                              )}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  {state?.isLoading &&
                    Array.from(new Array(10)).map((val, key) => {
                      return (
                        <tr key={key}>
                          <td width="5%">
                            <Skeleton variant="text" animation="wave" />
                          </td>
                          <td width="20%">
                            <Skeleton variant="text" animation="wave" />
                          </td>
                          <td width="20%">
                            <Skeleton variant="text" animation="wave" />
                          </td>
                          <td width="15%">
                            <Skeleton variant="text" animation="wave" />
                          </td>
                          <td width="40%">
                            <Skeleton variant="text" animation="wave" />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Withdraw;
